import { render, staticRenderFns } from "./s-order.vue?vue&type=template&id=aa638468&scoped=true&"
import script from "./s-order.vue?vue&type=script&lang=js&"
export * from "./s-order.vue?vue&type=script&lang=js&"
import style0 from "./s-order.vue?vue&type=style&index=0&id=aa638468&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa638468",
  null
  
)

export default component.exports